import axios from 'axios';

export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const LOGIN_URL = 'https://ft9ja.com/login';
// Cookie shared across every *.ft9ja.com subdomain (dashboard writes it on login).
export const COOKIE_DOMAIN = '.ft9ja.com';

function readCookie(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; Domain=${COOKIE_DOMAIN}; Path=/; Max-Age=0; SameSite=Lax; Secure`;
}

export function getAccessToken() {
  return readCookie(ACCESS_TOKEN_KEY) || localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return readCookie(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function clearAuthTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  deleteCookie(ACCESS_TOKEN_KEY);
  deleteCookie(REFRESH_TOKEN_KEY);
  delete axios.defaults.headers.common.Authorization;
}

export function redirectToLogin() {
  clearAuthTokens();
  window.location.href = LOGIN_URL;
}

export function requireAccessToken() {
  const token = getAccessToken();
  if (!token) {
    redirectToLogin();
    return null;
  }
  return token;
}

export function getAuthHeaders() {
  const token = getAccessToken();
  return {
    Authorization: token ? `Bearer ${token}` : null,
    'Content-Type': 'application/json',
    accept: 'application/json',
  };
}

export function isTokenNotValidError(error) {
  return error?.response?.data?.code === 'token_not_valid';
}

export function handleAuthError(error) {
  if (isTokenNotValidError(error)) {
    redirectToLogin();
    return true;
  }
  return false;
}

export function setupAuthInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isTokenNotValidError(error)) {
        redirectToLogin();
      }
      return Promise.reject(error);
    }
  );
}

export function syncAxiosAuthHeader() {
  const token = getAccessToken();
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}
